<template>
  <div class="module"></div>
</template>
<style lang="sass" scoped>

@import "src/styles/defaults/variables"
@import "src/styles/defaults/mobile-first"
.module
  &__group
    break-inside: avoid-column
    > div > *
      display: block
    &__levels-radios > *
      display: block
    +media-min-sm()
    +media-min-md()
      &__levels-radios > *
        display: inline-flex
    +media-min-lg()
      &__groups
        column-count: 2
</style>

<script>
export default {
  name: 'ModuleParameterization',
};
</script>
